var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/_isarray@1.0.0@isarray/index.js
// module id = 806
// module chunks = 115